import React, { useState } from "react";
import { getAxios } from "../../utils/endpoints";
import { User } from "../../model/User";

type Product = {
  id: string;
  description: string;
};

type Dealer = {
  dealerId: number;
  assignedProducts: number[];
};

type ProductResponse = {
  products: Product[];
  dealer: Dealer;
};

export const useProductPanel = (username?: string) => {
  const [assignedProducts, setAssignedProducts] = React.useState<number[]>([]);
  const [search, setSearch] = useState<string>("");
  const [products, setProducts] = React.useState<Product[]>([]);

  const [snackbarState, setSnackbarState] = useState({
    message: "",
    level: "",
    isOpen: false,
  });

  const user = new User();
  const selectedUsername = username ? username : user.UserName;

  const onFetchProducts = async (): Promise<void> => {
    const response = await getAxios(
      `/profile/product-map/${selectedUsername}`,
      "GET",
    );
    const pResponse = await getAxios(
      `/options/product`,
      "GET",
    );

    const data: Dealer = await response.data;
    const pData: Product[] = await pResponse.data;

    setAssignedProducts(data.assignedProducts);
    setProducts(pData);
  };

  const onCloseSnackbar = () => {
    setSnackbarState((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  };

  const assignProduct = (productId: number) => {
    if (assignedProducts.includes(productId)) {
      const filteredArr: number[] = assignedProducts.filter(
        (val) => val !== productId,
      );

      setAssignedProducts(filteredArr);
    } else {
      setAssignedProducts([...assignedProducts, productId]);
    }
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearch(event.target.value);
  };

  const onUpdateAssignedProducts = async (): Promise<void> => {
    try {
      const response = await getAxios(
        `/profile/product-map/${selectedUsername}`,
        "PUT",
        {
          ProductIds: assignedProducts,
          selectedUsername: selectedUsername,
        },
      );

      setSnackbarState({
        message: "Products has been updated",
        level: "success",
        isOpen: true,
      });
    } catch (error) {
      console.error(error);
      setSnackbarState({
        message: "Something went wrong",
        level: "error",
        isOpen: true,
      });
    }
  };

  React.useEffect(() => {
    onFetchProducts();
  }, []);

  return {
    search,
    snackbarState,
    assignProduct,
    assignedProducts,
    products,
    onChange,
    onUpdateAssignedProducts,
    onCloseSnackbar,
  };
};
